import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OptionFormTypes } from '../../../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../../../services/filtering/filter-form-render-service';
import messages from './messages';

export default {
  id: 'createdDate',
  displayName: <FormattedMessage {...messages.createdDate} />,
  type: OptionFormTypes.TYPE_DATE_COMPARISON_SHIPMENTS,
  filterValue: 'CreatedDateTime',
  render: (criteriaInformations) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_DATE_COMPARISON_SHIPMENTS, criteriaInformations);
  },
};
